var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPyramid(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 173.64 160.47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:none;stroke:#fff;stroke-linecap:round;stroke-linejoin:round;}.cls-1{stroke-width:0.35px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Diagram"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 69.55,
    y1: 10.47,
    x2: 86.82,
    y2: 20.43
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 69.55,
    y1: 30.4,
    x2: 86.82,
    y2: 40.37
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 86.82,
    y1: 0.5,
    x2: 69.55,
    y2: 10.47
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 69.55,
    y1: 30.4,
    x2: 69.55,
    y2: 10.47
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 104.08,
    y1: 10.47,
    x2: 86.82,
    y2: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 86.82,
    y1: 40.37,
    x2: 86.82,
    y2: 20.43
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 86.82,
    y1: 20.43,
    x2: 104.08,
    y2: 10.47
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 104.08,
    y1: 30.4,
    x2: 104.08,
    y2: 10.47
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 86.82,
    y1: 40.37,
    x2: 104.08,
    y2: 30.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 69.55,
    y1: 70.27,
    x2: 86.82,
    y2: 80.24
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 86.82,
    y1: 60.3,
    x2: 69.55,
    y2: 70.27
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 86.82,
    y1: 100.17,
    x2: 86.82,
    y2: 80.24
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 86.82,
    y1: 80.24,
    x2: 104.08,
    y2: 70.27
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 104.08,
    y1: 90.2,
    x2: 104.08,
    y2: 70.27
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 86.82,
    y1: 100.17,
    x2: 104.08,
    y2: 90.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 138.61,
    y1: 130.07,
    x2: 155.87,
    y2: 140.04
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 138.61,
    y1: 150.01,
    x2: 155.87,
    y2: 159.97
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 138.61,
    y1: 150.01,
    x2: 138.61,
    y2: 130.07
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 173.14,
    y1: 130.07,
    x2: 155.87,
    y2: 120.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 155.87,
    y1: 159.97,
    x2: 155.87,
    y2: 140.04
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 155.87,
    y1: 140.04,
    x2: 173.14,
    y2: 130.07
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 173.14,
    y1: 150.01,
    x2: 173.14,
    y2: 130.07
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 155.87,
    y1: 159.97,
    x2: 173.14,
    y2: 150.01
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 35.03,
    y1: 130.07,
    x2: 52.29,
    y2: 140.04
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 35.03,
    y1: 150.01,
    x2: 52.29,
    y2: 159.97
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 52.29,
    y1: 120.11,
    x2: 35.03,
    y2: 130.07
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 52.29,
    y1: 159.97,
    x2: 52.29,
    y2: 140.04
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 52.29,
    y1: 140.04,
    x2: 69.55,
    y2: 130.07
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 52.29,
    y1: 159.97,
    x2: 69.55,
    y2: 150.01
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 17.76,
    y1: 100.17,
    x2: 35.03,
    y2: 110.14
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 35.03,
    y1: 90.2,
    x2: 17.76,
    y2: 100.17
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 17.76,
    y1: 120.11,
    x2: 17.76,
    y2: 100.17
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 35.03,
    y1: 130.07,
    x2: 35.03,
    y2: 110.14
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 35.03,
    y1: 110.14,
    x2: 52.29,
    y2: 100.17
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 69.55,
    y1: 130.07,
    x2: 86.82,
    y2: 140.04
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 69.55,
    y1: 150.01,
    x2: 86.82,
    y2: 159.97
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 86.82,
    y1: 120.11,
    x2: 69.55,
    y2: 130.07
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 69.55,
    y1: 150.01,
    x2: 69.55,
    y2: 130.07
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 86.82,
    y1: 159.97,
    x2: 86.82,
    y2: 140.04
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 86.82,
    y1: 140.04,
    x2: 104.08,
    y2: 130.07
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 104.08,
    y1: 150.01,
    x2: 104.08,
    y2: 130.07
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 86.82,
    y1: 159.97,
    x2: 104.08,
    y2: 150.01
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 52.29,
    y1: 100.17,
    x2: 69.55,
    y2: 110.14
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 52.29,
    y1: 120.11,
    x2: 69.55,
    y2: 130.07
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 69.55,
    y1: 90.2,
    x2: 52.29,
    y2: 100.17
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 52.29,
    y1: 120.11,
    x2: 52.29,
    y2: 100.17
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 86.82,
    y1: 100.17,
    x2: 69.55,
    y2: 90.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 69.55,
    y1: 130.07,
    x2: 69.55,
    y2: 110.14
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 69.55,
    y1: 110.14,
    x2: 86.82,
    y2: 100.17
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 86.82,
    y1: 120.11,
    x2: 86.82,
    y2: 100.17
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 121.34,
    y1: 100.17,
    x2: 138.61,
    y2: 110.14
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 155.87,
    y1: 100.17,
    x2: 138.61,
    y2: 90.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 138.61,
    y1: 130.07,
    x2: 138.61,
    y2: 110.14
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 138.61,
    y1: 110.14,
    x2: 155.87,
    y2: 100.17
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 155.87,
    y1: 120.11,
    x2: 155.87,
    y2: 100.17
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 138.61,
    y1: 130.07,
    x2: 155.87,
    y2: 120.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 104.08,
    y1: 130.07,
    x2: 121.34,
    y2: 140.04
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 104.08,
    y1: 150.01,
    x2: 121.34,
    y2: 159.97
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 121.34,
    y1: 120.11,
    x2: 104.08,
    y2: 130.07
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 138.61,
    y1: 130.07,
    x2: 121.34,
    y2: 120.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 121.34,
    y1: 159.97,
    x2: 121.34,
    y2: 140.04
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 121.34,
    y1: 140.04,
    x2: 138.61,
    y2: 130.07
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 121.34,
    y1: 159.97,
    x2: 138.61,
    y2: 150.01
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 104.08,
    y1: 70.27,
    x2: 121.34,
    y2: 80.24
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 138.61,
    y1: 70.27,
    x2: 121.34,
    y2: 60.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 121.34,
    y1: 100.17,
    x2: 121.34,
    y2: 80.24
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 121.34,
    y1: 80.24,
    x2: 138.61,
    y2: 70.27
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 138.61,
    y1: 90.2,
    x2: 138.61,
    y2: 70.27
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 121.34,
    y1: 100.17,
    x2: 138.61,
    y2: 90.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 0.5,
    y1: 130.07,
    x2: 17.76,
    y2: 140.04
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 0.5,
    y1: 150.01,
    x2: 17.76,
    y2: 159.97
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 17.76,
    y1: 120.11,
    x2: 0.5,
    y2: 130.07
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 0.5,
    y1: 150.01,
    x2: 0.5,
    y2: 130.07
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 35.03,
    y1: 130.07,
    x2: 17.76,
    y2: 120.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 17.76,
    y1: 159.97,
    x2: 17.76,
    y2: 140.04
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 17.76,
    y1: 140.04,
    x2: 35.03,
    y2: 130.07
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 35.03,
    y1: 150.01,
    x2: 35.03,
    y2: 130.07
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 17.76,
    y1: 159.97,
    x2: 35.03,
    y2: 150.01
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 86.82,
    y1: 100.17,
    x2: 104.08,
    y2: 110.14
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 86.82,
    y1: 120.11,
    x2: 104.08,
    y2: 130.07
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 121.34,
    y1: 100.17,
    x2: 104.08,
    y2: 90.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 104.08,
    y1: 130.07,
    x2: 104.08,
    y2: 110.14
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 104.08,
    y1: 110.14,
    x2: 121.34,
    y2: 100.17
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 121.34,
    y1: 120.11,
    x2: 121.34,
    y2: 100.17
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 35.03,
    y1: 70.27,
    x2: 52.29,
    y2: 80.24
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 35.03,
    y1: 90.2,
    x2: 52.29,
    y2: 100.17
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 52.29,
    y1: 60.3,
    x2: 35.03,
    y2: 70.27
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 35.03,
    y1: 90.2,
    x2: 35.03,
    y2: 70.27
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 52.29,
    y1: 100.17,
    x2: 52.29,
    y2: 80.24
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 52.29,
    y1: 80.24,
    x2: 69.55,
    y2: 70.27
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 69.55,
    y1: 90.2,
    x2: 69.55,
    y2: 70.27
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 52.29,
    y1: 40.37,
    x2: 69.55,
    y2: 50.34
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 52.29,
    y1: 60.3,
    x2: 69.55,
    y2: 70.27
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 69.55,
    y1: 30.4,
    x2: 52.29,
    y2: 40.37
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 52.29,
    y1: 60.3,
    x2: 52.29,
    y2: 40.37
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 69.55,
    y1: 70.27,
    x2: 69.55,
    y2: 50.34
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 69.55,
    y1: 50.34,
    x2: 86.82,
    y2: 40.37
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 86.82,
    y1: 60.3,
    x2: 86.82,
    y2: 40.37
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 86.82,
    y1: 40.37,
    x2: 104.08,
    y2: 50.34
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 86.82,
    y1: 60.3,
    x2: 104.08,
    y2: 70.27
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 121.34,
    y1: 40.37,
    x2: 104.08,
    y2: 30.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 104.08,
    y1: 70.27,
    x2: 104.08,
    y2: 50.34
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 104.08,
    y1: 50.34,
    x2: 121.34,
    y2: 40.37
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 121.34,
    y1: 60.3,
    x2: 121.34,
    y2: 40.37
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 104.08,
    y1: 70.27,
    x2: 121.34,
    y2: 60.3
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "69.55 10.47 86.82 0.5 104.08 10.47 104.08 30.4 121.34 40.37 121.34 60.3 138.61 70.27 138.61 90.2 155.87 100.17 155.87 120.11 173.13 130.07 173.13 150.01 155.87 159.97 138.61 150.01 121.34 159.97 104.08 150.01 86.82 159.97 69.55 150.01 52.29 159.97 35.03 150.01 17.76 159.97 0.5 150.01 0.5 130.07 17.76 120.11 17.76 100.17 35.03 90.2 35.03 70.27 52.29 60.3 52.29 40.37 69.55 30.4 69.55 10.47"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPyramid);
export default __webpack_public_path__ + "static/media/pyramid.fbe7f0eaaee75ad206941ccd3ad69acd.svg";
export { ForwardRef as ReactComponent };